if (!customElements.get("quick-add-modal")) {
  customElements.define(
    "quick-add-modal",
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener("product-info:loaded", ({ target }) => {
          if (target && typeof target.addPreProcessCallback === "function") {
            target.addPreProcessCallback(this.preprocessHTML.bind(this));
          }
        });
      }

      hide(preventFocus = false) {
        this.modalContent.innerHTML = "";

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      initializeSliderDrag(container) {
        const slider = container.querySelector(".slider");
        if (slider && !slider.classList.contains("drag-initialized")) {
          slider.classList.add("drag-initialized");

          const sliderInstance = slider.closest("slider-component");
          if (sliderInstance && typeof sliderInstance.addDragToScroll === "function") {
            sliderInstance.addDragToScroll();
          }
        }
      }

      show(opener) {
        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");
        super.show(opener);
        if (this.modalContent) {
          this.modalContent.innerHTML = "";
          const loaderContainer = document.createElement("div");
          loaderContainer.className = "quick-add__spinner show";
          loaderContainer.innerHTML = '<span class="loader"></span>';
          this.modalContent.appendChild(loaderContainer);
        }

        const productHandle = opener.getAttribute("data-handle");
        const root = window.Shopify?.routes?.root || "/";
        fetch(`${root}products/${productHandle}?view=quick-view`)
          .then((response) => response.text())
          .then((responseText) => {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = responseText;

            const productElement = tempDiv.querySelector("product-info");

            if (!productElement) {
              return;
            }

            productElement.querySelectorAll("[id]").forEach((el) => {
              const name = el.getAttribute("name") || "";

              const should_not_add =
                name.includes("product-variant-id") ||
                name.includes("form_type") ||
                name.includes("utf8") ||
                name.includes("id");

              if (!should_not_add) {
                const next = el.nextElementSibling;
                if (next && next.tagName.toLowerCase() === "label" && next.getAttribute("for") === el.id) {
                  next.setAttribute("for", el.id + "--quickview");
                }
                el.id = el.id + "--quickview";
              }
            });
            productElement.querySelectorAll("[name]").forEach((el) => {
              const name = el.getAttribute("name") || "";

              const should_not_add =
                name.includes("product-variant-id") ||
                name.includes("form_type") ||
                name.includes("utf8") ||
                name.includes("id") ||
                name.includes("State") ||
                name.includes("Detail");

              if (!should_not_add) {
                el.name = el.name + "--quickview";
              }
            });

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement?.outerHTML);
            this.modalContent.dispatchEvent(new CustomEvent("product-info:loaded", { bubbles: true }));
            const modalSwatches = this.modalContent.querySelectorAll(".swatch-input__input");
            const addToBagContainer = this.modalContent.querySelector(".buy-buttons-container");
            const addToBagForm = addToBagContainer ? addToBagContainer.querySelector("form") : null;

            this.modalContent.querySelectorAll(".tone-button-wrapper").forEach((button) => {
              button.addEventListener("click", () => {
                const input = button.querySelector("input");
                input.checked = true;
                filterShadesQuickView(this.modalContent);
              });
            });

            if (addToBagForm) {
              addToBagForm.classList.add("quick-add-to-bag");
            }

            modalSwatches.forEach((swatch) => {
              swatch.addEventListener("click", (event) => {
                event.preventDefault();
              });
            });

            applyQuickViewGalleryChange(this.modalContent);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");
            this.initializeSliderDrag(this);
          });
      }

      preprocessHTML(productElement) {
        if (productElement) {
          productElement.classList.forEach((classApplied) => {
            if (classApplied.startsWith("color-") || classApplied === "gradient")
              this.modalContent.classList.add(classApplied);
          });
          this.removeDOMElements(productElement);
          this.updateImageSizes(productElement);
          this.preventVariantURLSwitching(productElement);
        }
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute("data-update-url", "false");
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector("pickup-availability");
        if (pickupAvailability) pickupAvailability.remove();

        const quickAddHiddenList = productElement.querySelectorAll(".quick-add-hidden");
        quickAddHiddenList.forEach((item) => {
          if (item) item.remove();
        });
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector(".product");
        if (!product) return;
        const mediaImages = product.querySelectorAll(".product__media img");
        if (!mediaImages.length) return;

        mediaImages.forEach((image) => {
          image?.closest(".lazy-image")?.classList.add("loaded");
          const skeleton = image?.closest(".lazy-image")?.previousElementSibling;
          if (skeleton && skeleton.classList.contains("image-skeleton")) {
            skeleton.classList.add("hidden");
          }
        });

        const desktopColumns = product?.classList.contains("product--columns");
        if (!desktopColumns) return;

        let mediaImageSizes =
          "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

        if (product.classList.contains("product--medium")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "605px");
        } else if (product.classList.contains("product--small")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "495px");
        }

        mediaImages.forEach((img) => img.setAttribute("sizes", mediaImageSizes));
      }
    },
  );
}
